import {useLayoutEffect, type ReactNode} from "react";
import {createPortal} from "react-dom";
import {useAsidePanelContextSafe} from "~/contexts/asidePanelContext";

export function AsidePanelPortal({
    children,
    isFullscreen,
}: {
    children: ReactNode;
    isFullscreen: boolean;
}) {
    const context = useAsidePanelContextSafe();
    const setIsOpen = context?.setIsOpen;
    const setIsFullscreen = context?.setIsFullscreen;
    const portalTarget = context?.portalTarget ?? null;
    const isOpen = context?.state.isOpen === true;

    useLayoutEffect(() => {
        if (setIsOpen === undefined || setIsFullscreen === undefined) {
            return;
        }
        setIsOpen(true);
        setIsFullscreen(isFullscreen);
        return () => {
            setIsOpen(false);
            setIsFullscreen(false);
        };
    }, [setIsOpen, setIsFullscreen, isFullscreen]);

    if (isOpen !== true || portalTarget === null) {
        return null;
    }

    return createPortal(
        <div className="grid h-full min-h-0 min-w-0 w-full overflow-hidden">{children}</div>,
        portalTarget,
    );
}
